var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-vertical-navigation',{attrs:{"menu":_vm.menu},on:{"collapse":_vm.on_collapse,"item_click":_vm.on_item_click}})}
var staticRenderFns = []

export { render, staticRenderFns }